import { render } from "./BookingStep2.vue?vue&type=template&id=0c2afb74"
import script from "./BookingStep2.vue?vue&type=script&lang=js"
export * from "./BookingStep2.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/apps/BookingStep2.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0c2afb74"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0c2afb74', __exports__)) {
    api.reload('0c2afb74', __exports__)
  }
  
  module.hot.accept("./BookingStep2.vue?vue&type=template&id=0c2afb74", () => {
    api.rerender('0c2afb74', render)
  })

}


export default __exports__